export default "__VITE_ASSET__52fbb9f2__"